import { render, staticRenderFns } from "./globalMydivecenterList.vue?vue&type=template&id=36fa9137&scoped=true&"
import script from "./globalMydivecenterList.vue?vue&type=script&lang=js&"
export * from "./globalMydivecenterList.vue?vue&type=script&lang=js&"
import style0 from "./globalMydivecenterList.vue?vue&type=style&index=0&id=36fa9137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa9137",
  null
  
)

export default component.exports